import { useEffect, useState } from "react";

/**
 * Delays the visibility of transient UI so quick async work can stay quiet
 * while slower requests still surface helpful feedback.
 *
 * @param {boolean} visible - Whether the host UI is currently active.
 * @param {number} [delayMs=400] - Delay before exposing the dependent UI.
 * @returns {boolean} Delayed visibility flag.
 */
export function useDelayedVisibility(visible, delayMs = 400) {
  const [delayedVisible, setDelayedVisible] = useState(false);

  useEffect(() => {
    if (!visible) {
      setDelayedVisible(false);
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      setDelayedVisible(true);
    }, delayMs);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [delayMs, visible]);

  return delayedVisible;
}

export default useDelayedVisibility;
